import { render, staticRenderFns } from "./ReportingUnit.vue?vue&type=template&id=79aef8f6"
import script from "./ReportingUnit.vue?vue&type=script&lang=js"
export * from "./ReportingUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports